// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"b9ccc677b775ace2f10d","589":"ddf622f125c341305c0f","691":"aec339b2bcf51dae031e"}[chunkId] + ".js";
};